import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  multiCarrier: {
    description: 'Label shown when multiple carriers are selected in bulk label flow',
    defaultMessage: 'Multi-Carrier',
    id: 'TZ3GbD',
  },
  title: {
    description: 'Wallet Registration mobile modal header',
    defaultMessage: 'ShipStation Services Setup',
    id: 'qXMM58',
  },
  buyFirstLabelTitle: {
    description: 'Wallet Registration modal header for first label purchase',
    defaultMessage: 'Buy Your First Label',
    id: 'MSHPXd',
  },
  activateSavingsTitle: {
    description: 'Wallet Registration modal header to activate savings on carrier rates',
    defaultMessage: 'Activate Savings on Carrier Rates',
    id: 'DjvpoU',
  },
  backButton: {
    description: 'Generic wallet back step',
    defaultMessage: 'Back to {previousStepLabel}',
    id: 'T8wTox',
  },
  cancel: {
    description: 'Wallet Registration modal cancel button',
    defaultMessage: 'Cancel',
    id: '6ce7MW',
  },
  continueSetup: {
    description: 'Wallet Registration modal continue setup button',
    defaultMessage: 'Continue Setup',
    id: 'zSeyEd',
  },
  continueWithPayByBank: {
    description: 'Wallet Registration modal continue with pay by bank button',
    defaultMessage: 'Continue with Pay by Bank',
    id: 'CpF44j',
  },
  finishSetup: {
    description: 'Wallet Registration modal finish setup button',
    defaultMessage: 'Finish Setup',
    id: 'YjyrQ7',
  },
  fundLater: {
    description: 'Wallet Registration modal fund later button',
    defaultMessage: 'Fund Later',
    id: 'nK7QqI',
  },
  fundLaterTooltip: {
    description: 'Tooltip for fund later button when terms not accepted',
    defaultMessage: 'You must accept the terms before you can register the wallet',
    id: 'CbToHO',
  },
  fundAmount: {
    description: 'Wallet Registration modal fund amount label',
    defaultMessage: 'Fund {amount}',
    id: 'j3ybnG',
  },
  updateButton: {
    description: 'One step carrier update submit button',
    defaultMessage: 'Update',
    id: 'Qy5E6/',
  },
  paymentTab: {
    description: 'Wallet Registration modal payment tab',
    defaultMessage: 'Payment',
    id: 'KC72wt',
  },
  termsTab: {
    description: 'Wallet Registration modal terms tab',
    defaultMessage: 'Terms',
    id: '9uWXVh',
  },
  addFundsTab: {
    description: 'Wallet Registration modal add funds tab',
    defaultMessage: 'Add Funds',
    id: 'wVK/TR',
  },
  termsOfService: {
    description: 'Wallet Registration modal terms tab header',
    defaultMessage: 'Terms of Service',
    id: '5aISgV',
  },
  termsCheckbox: {
    description: 'Wallet Registration modal terms checkbox',
    defaultMessage: 'I have read and agree to the following terms of service:',
    id: 'TJJsBi',
  },
  saveOnRates: {
    description: 'Start tab header',
    defaultMessage: 'Save on rates for these carriers too!',
    id: '7YZRp0',
  },
  firstLabel: {
    description: 'Start tab header',
    defaultMessage: 'Buying your first label with a ShipStation Carrier',
    id: 'czJD4K',
  },
  update: {
    description: 'Update carrier service tab header',
    defaultMessage: 'Update {brand}',
    id: 's1h4Pf',
  },
  firstLabelDirections: {
    description: 'Start tab directions',
    defaultMessage:
      'You get up to an 89% savings immediately with the following popular carriers when you ship with ShipStation. <a>Learn more</a>',
    id: '13z3XQ',
  },
  whatsNew: {
    description: 'Modal header referring to adding new carriers and new carrier services',
    defaultMessage: "What's New",
    id: 'FbX4WH',
  },
  carrierServices: {
    description: 'Carrier services section title',
    defaultMessage: 'Carrier Services',
    id: 'c/9WxW',
  },
  carriers: {
    description: 'Carriers section title',
    defaultMessage: 'Carriers',
    id: 'BYQa2o',
  },
  updateDirections: {
    description: 'Update tab directions',
    defaultMessage: "We're always adding new carriers and services with discounted rates, here's what's new.",
    id: 'P3r/JK',
  },
  setExistingCarrierText: {
    description: 'Start tab text to set up other carriers',
    defaultMessage:
      'Prefer to use your own carrier account? You can connect with a multitude of carriers through ShipStation in <link>Settings</link>.',
    id: 'WFmhoh',
  },
  registrationSuccessTitle: {
    description: 'Success notification title',
    defaultMessage: 'Carrier added',
    id: '7qbldO',
  },
  registrationSuccessContent: {
    description: 'Success notification content',
    defaultMessage: 'Carrier successfully added to your account.',
    id: 'pUsfHu',
  },
  accountNickName: {
    description: 'Wallet Registration modal account nick name',
    defaultMessage: 'Account Nickname',
    id: 'ZyJJr3',
  },
  accountNicknameSubtext: {
    description: 'Subtext for account nickname description',
    defaultMessage: 'Nickname will be used to label and differentiate carriers associated with this account.',
    id: 'FxSdDL',
  },
  stampsCredentialsPrompt: {
    description: 'Prompt for seller to use their own account credentials for a wallet',
    defaultMessage: 'Link ShipStation and my Stamps.com account',
    id: 'XCAKXD',
  },
  stampsUsername: {
    description: 'label for stamps username',
    defaultMessage: 'Stamps.com Username',
    id: 'ZM7ebT',
  },
  stampsPassword: {
    description: 'label for stamps.com password',
    defaultMessage: 'Stamps.com Password',
    id: 'E0dzwv',
  },
  pickupAddressPrompt: {
    description: 'Prompt to use pickup address as billing address',
    defaultMessage: 'Use as Pickup Address',
    id: 'uV7gJE',
  },
  pickupAddressTooltip: {
    description: 'Tooltip text for pickup address checkbox',
    defaultMessage: 'Set this as your default pick up address.',
    id: 'Giz6Mm',
  },
  pickupAddressHeader: {
    description: 'Pickup address header',
    defaultMessage: 'Pickup Address',
    id: 'UsOfU4',
  },
  stampsCredentialsPreviewHeader: {
    description: 'Header for preview text when using stamps account credentials as a wallet payment method',
    defaultMessage: 'Payment Method',
    id: 'JU45cJ',
  },
  stampsCredentialsPreview: {
    description: 'Preview text when using stamps account credentials as a wallet payment method',
    defaultMessage:
      'Using payment method associated with Stamps.com account <b>{username}</b>. Payments will appear on your credit card statement from “Stamps.com”.',
    id: 'ssfwWb',
  },
  creditCardPaymentMessage: {
    description: 'Simple message telling the user about the expected billing statement for their wallet',
    defaultMessage: 'Payments will appear on your credit card statement from “Stamps.com”',
    id: '0b/kdF',
  },
  creditCardPaymentMessageAuOnly: {
    description: 'Simple message telling the user about the expected transaction fees for their wallet for AU merchants only',
    defaultMessage:
      'Your financial institution may apply transaction fees to purchases made in ShipStation. Please contact your card provider for details.',
    id: 'qYFvuM',
  },
  paymentTabHeader: {
    description: 'Wallet Registration modal payment tab header',
    defaultMessage: 'Billing Address and Payment Details',
    id: 'yuvLBv',
  },
  personalRadioButton: {
    description: 'Radio button for labeling personal accounts',
    defaultMessage: 'Personal',
    id: 'easTPN',
  },
  businessRadioButton: {
    description: 'Radio button for labeling business accounts',
    defaultMessage: 'Business',
    id: 'i86ML+',
  },
  accountType: {
    description: 'Radio button label',
    defaultMessage: 'Account Type',
    id: 'nucz2o',
  },
  amountToAdd: {
    description: 'Add funds tab amount to add',
    defaultMessage: 'Amount',
    id: 'rNc2fJ',
  },
  addFundsAndCreateLabelButton: {
    description: 'Finish setup and create label button',
    defaultMessage: 'Finish Setup & Create Label',
    id: '5/aedR',
  },
  addFundsErrorTitle: {
    description: 'Title for add funds error message',
    defaultMessage: 'An Error has Occurred',
    id: 'ylouFJ',
  },
  addFundsErrorContent: {
    description: 'Content for add funds error message',
    defaultMessage: 'An error has occurred while trying to add funds to your account.',
    id: 'LEE0eK',
  },
  addFundsSuccessTitle: {
    description: 'Title for add funds success message',
    defaultMessage: 'Funds Added',
    id: 'HeGf43',
  },
  addFundsSuccessContent: {
    description: 'Content for add funds success message',
    defaultMessage: 'Funds were successfully added to your wallet.',
    id: 'StIisP',
  },
  exitLabelCreationText: {
    description: 'Exit Label creation without adding funds',
    defaultMessage: 'Exit Label Creation',
    id: '3mbk0n',
  },
  exitLabelCreationBodyText: {
    description: 'Text for exiting register wallet/create label modal',
    defaultMessage:
      'Your services and payment information have been saved, but continuing will not add funds to your balance and will stop the label purchase. You are still able to add funds or buy the label at any time after closing this window.',
    id: 'y2Z8nP',
  },
  exitAddFundsBodyText: {
    description: 'Text for exiting add funds modal confirm dialog message',
    defaultMessage:
      "ShipStation Carriers has been activated but you don't yet have any funds in your balance. Are you sure you want to exit? {br} {br} You can add funds later in Settings or when you create a label.",
    id: '8qOQFE',
  },
  exitWalletRegistrationText: {
    description: 'Header text to exit ShipStation Carrier Setup without setting up wallet',
    defaultMessage: 'Exit ShipStation Carrier Setup',
    id: '6RDzqm',
  },
  exitWalletRegistrationBodyText: {
    description: 'Body text for exiting ShipStation Carrier Setup',
    defaultMessage: 'You have not finished activating ShipStation Carriers. Are you sure you want to exit?',
    id: 'mvKs6K',
  },
  exitWalletRegistrationBodyTextWithUserInput: {
    description: 'Body text for exiting ShipStation Carrier Setup when a user has input information',
    defaultMessage:
      'You have not finished activating ShipStation Carriers and your settings will not be saved. Are you sure you want to exit?',
    id: 'TmDskM',
  },
  exitWalletRegistrationButtonText: {
    description: 'Button text for exiting ShipStation Carrier Setup',
    defaultMessage: 'Exit Setup',
    id: '6cOlHc',
  },
  addFundsFromPrintButtonTitle: {
    description: 'Title for add funds tab started from the print label button',
    defaultMessage: 'Pay for this label and be ready for future shipments',
    id: 'hI6CWf',
  },
  currentLabelPurchase: {
    description: 'Text in add funds tab to show seller the current label purchase amount',
    defaultMessage: 'Current label purchase',
    id: 'q+k9No',
  },
  autoFundCheckboxLabel: {
    description: 'Text in add funds tab to give seller option to turn on autofunding',
    defaultMessage: 'Auto-fund for future purchases',
    id: 'qwiaLQ',
  },
  whenBalanceFallsBelow: {
    description: 'Label for auto-fund threshold input',
    defaultMessage: 'When balance falls below',
    id: '/LkRns',
  },
  addTheFollowingAmount: {
    description: 'Label for auto-fund amount input',
    defaultMessage: 'Add the following amount',
    id: 'NDEhnw',
  },
  autoFundAmount: {
    description: 'Label for auto-fund amount in add funds modal',
    defaultMessage: 'Auto-fund amount',
    id: 'lq250m',
  },
  maximumTimesPerDay: {
    description: 'Label for maximum daily funding times input',
    defaultMessage: 'Maximum times per day',
    id: 'd+g1fo',
  },
  addIfBelow: {
    description: 'Label for auto-fund threshold in condensed layout',
    defaultMessage: 'Add funds if below',
    id: 'WHZzCf',
  },
  maxFunding: {
    description: 'Label for maximum funding per day in condensed layout',
    defaultMessage: 'Max funding',
    id: '1ySPSC',
  },
  timesPerDay: {
    description: 'Label suffix for times per day input',
    defaultMessage: 'times per day',
    id: 'zdxuP6',
  },
  viewSettings: {
    description: 'Label for link to view auto fund settings',
    defaultMessage: 'View Settings',
    id: '+f/vky',
  },
  makeDefault: {
    description: 'Checkbox label for making amount default to add to wallet',
    defaultMessage: 'Make default funding amount',
    id: 'sWKOtR',
  },
  firstLabelHeader: {
    description: 'First label header',
    defaultMessage: 'You’re about to buy your first label!',
    id: 'NdUi6l',
  },
  firstLabelSubHeader: {
    description: 'First label subheader',
    defaultMessage: 'When you buy a label in ShipStation, you instantly gain the benefits from our excellent partnerships.',
    id: '89eB4T',
  },
  doesNotPurchase: {
    description: 'Subtext explaining that buying a label does not purchase a subscription plan.',
    defaultMessage:
      'This process does not purchase a subscription plan for ShipStation. You can purchase a subscription at any time during your trial period.',
    id: 'kouIn6',
  },
  savingDirections: {
    description: 'Directions on how to start printing labels with Shipstation Balance',
    defaultMessage:
      'To start printing labels with our affordable rates, enter your payment details, agree to terms and conditions, and then set up your ShipStation Balance, our built-in label budgeting tool.',
    id: 'IpWvj4',
  },
  savingDirectionsWithInsurance: {
    description: 'Directions on how to start printing labels and insurance with Shipstation Balance',
    defaultMessage:
      'To start printing labels with our affordable rates and insurance coverage, enter your payment details, agree to terms and conditions, and then set up your ShipStation Balance - our built-in label budgeting tool.',
    id: 'x4qzqR',
  },
  saveOnShipping: {
    description: 'Start saving on shipping header',
    defaultMessage: 'Start saving on Shipping!',
    id: '8fp/3K',
  },
  autoInsureTitle: {
    description: 'Prompt to add insurance to all shipments',
    defaultMessage: 'Include Shipping Insurance on all shipments',
    id: 'XWiAAa',
  },
  optional: {
    description: 'Label stating that the input is not required',
    defaultMessage: '(Optional)',
    id: 'AgUsL9',
  },
  autoInsureLabel: {
    description: 'Label for checkbox to add insurance to all shipments',
    defaultMessage: 'Automatically add {insuranceProviderName} to all future shipments',
    id: 'j57Mn0',
  },
  includeInsuranceLabel: {
    description: 'Label for checkbox to include insurance with all future shipments',
    defaultMessage: 'Include insurance with all future shipments',
    id: 'evAd1T',
  },
  autoInsureDisclaimer: {
    description: 'Disclaimer for insurance checkbox, reminding that this can be changed at any time',
    defaultMessage:
      'Insurance will be added when the package value is not covered by carrier insurance. You can adjust this anytime via Insurance Settings.',
    id: '4c+j3o',
  },
  autoInsureDisclaimer2: {
    description: 'Disclaimer for insurance checkbox, describing that not all orders can be insured',
    defaultMessage: 'Some exclusions apply. See <a>Terms & Conditions</a>',
    id: 'F8sf1n',
  },
  updateCarriersHeader: {
    description: 'Header for update carriers and services modal',
    defaultMessage: 'Update Services',
    id: 'TsTnaS',
  },
  updateModalLeftHeader: {
    description: 'update modal header for left side',
    defaultMessage: "You've got new ways to ship!",
    id: 'LnqTVt',
  },
  updateModalLeftInfo: {
    description: 'Message and instructions for setting up services available to the user',
    defaultMessage:
      "We've added new services with discounted rates. To add the new services, please read and accept the updated Terms of Service.",
    id: 'SgKNCr',
  },
  updateModalLeftSubHeader: {
    description: 'update modal sub-header for left side',
    defaultMessage: 'Terms of Service',
    id: 'YPasWM',
  },
  updateModalLeftSideAgreement: {
    description: 'update modal text for checkbox',
    defaultMessage: 'I have read and agree to the following terms of service:',
    id: 'EnRvh4',
  },
  updateModalRightHeader: {
    description: 'update modal header for right side',
    defaultMessage: "What's new",
    id: 'bKY7+M',
  },
  updateModalRightInfo: {
    description: 'Message describing services available to the user',
    defaultMessage: 'The following services are newly available to you or have been updated.',
    id: 'O8JOUm',
  },
  updateModalRightMoreInfo: {
    description: 'update modal more info for right side',
    defaultMessage: 'For more information, visit our <kb>ShipStation Carriers guide</kb>.',
    id: 'fPOakh',
  },
  approvalRequestedNotificationTitle: {
    description: 'notification title when a walleted carrier needing approval is requested via wallet registration/update',
    defaultMessage: 'Request received!',
    id: 'wwEgrY',
  },
  approvalRequestedNotificationContent: {
    description: 'notification content when a walleted carrier needing approval is requested via wallet registration/update',
    defaultMessage: 'New carrier services will be available to use soon. Please <link>contact support</link> if you have any questions.',
    id: 'QCUbgE',
  },
  approvalGrantedNotificationTitle: {
    description: 'Title for the notification message when a walleted carrier needing approval is granted',
    defaultMessage: '{carrierName} Services Now Available',
    id: '62z549',
  },
  approvalGrantedNotificationContent: {
    description: 'Message for the notification message when a walleted carrier needing approval is granted',
    defaultMessage:
      'Start shipping with {carrierName} services right away! You can also manage your {carrierName} preferences in Carrier settings.',
    id: 'wSoJNL',
  },
  approvalGrantedCallToAction: {
    description: 'Call to action button message in the notification shown when a walleted carrier needing approval is granted',
    defaultMessage: 'Go to orders',
    id: 'A2y+P8',
  },
  approvalGrantedManageCarriers: {
    description: 'Manage carriers button message in the notification shown when a walleted carrier needing approval is granted',
    defaultMessage: 'Manage Carriers',
    id: 'l+OobN',
  },
  shipstationBalanceDescription: {
    description: 'Description text explaining ShipStation balance functionality',
    defaultMessage:
      'Your ShipStation balance allows you to purchase labels without interruption. Add funds now or fund your account later.',
    id: 'B7oluv',
  },
  shipstationBalanceDescriptionLabelFlow: {
    description: 'Description text for ShipStation balance when creating a label',
    defaultMessage:
      'Purchase a label by first funding your ShipStation balance. Your ShipStation balance allows you to purchase labels without interruption.',
    id: 'x6w2j+',
  },
  shipstationBalanceTitle: {
    description: 'Title for ShipStation Balance section',
    defaultMessage: 'ShipStation Balance',
    id: 'esfEIK',
  },
  shipstationBalanceTooltip: {
    description: 'Tooltip text explaining what ShipStation balance is used for',
    defaultMessage: 'Your ShipStation balance is used to purchase shipping labels and services.',
    id: 'a0P8/l',
  },
  labelCost: {
    description: 'Title text for label cost section showing the carrier and cost',
    defaultMessage: 'Label Cost',
    id: 'SnIMbE',
  },
  upsTermsLabel: {
    description: 'UPS terms acceptance checkbox label with links to terms documents',
    defaultMessage:
      'I agree that my shipping activity will be governed by the following terms: {supplemental}, {technology}, and {prohibited}.',
    id: 'preEye',
  },
  fundsToAdd: {
    description: 'Label for funds to add in summary section',
    defaultMessage: 'Funds to add',
    id: 'vPEKTl',
  },
  creditCardProcessingFee: {
    description: 'Label for credit card processing fee with percentage',
    defaultMessage: 'Credit card processing fee {percentage}%',
    id: 'novAx9',
  },
  creditCardProcessingFeeTooltip: {
    description: 'Tooltip explaining credit card processing fee',
    defaultMessage: 'A processing fee is applied to credit card transactions.',
    id: 'sjH/D4',
  },
  total: {
    description: 'Label for total amount in summary',
    defaultMessage: 'Total',
    id: 'UGrDJy',
  },
});
